import clsx from 'clsx';

export interface IconCheckProps {
  className?: string;
}

const IconCheck = ({ className }: IconCheckProps) => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      'transition-all duration-300 motion-reduce:transition-none',
      className,
    )}
  >
    <path d="M7.76674 15.4336C7.58861 15.4336 7.41634 15.4 7.24994 15.3328C7.08354 15.2667 6.92247 15.1557 6.76674 15L1.13314 9.36641C0.866475 9.09974 0.739008 8.76107 0.750742 8.35041C0.761408 7.93867 0.900075 7.59947 1.16674 7.33281C1.43341 7.06614 1.76674 6.93281 2.16674 6.93281C2.56674 6.93281 2.90008 7.06614 3.16674 7.33281L7.83394 12L18.8675 0.966406C19.1342 0.69974 19.4617 0.566406 19.8499 0.566406C20.2393 0.566406 20.5673 0.69974 20.8339 0.966406C21.1006 1.23307 21.2339 1.56107 21.2339 1.95041C21.2339 2.33867 21.1006 2.66614 20.8339 2.93281L8.76674 15C8.61101 15.1557 8.44994 15.2667 8.28354 15.3328C8.11714 15.4 7.94488 15.4336 7.76674 15.4336Z" />
  </svg>
);

export default IconCheck;
